const GlobalLoader = ({ loaderBackground = "", page = "" }) => {
  return (
    <div className={`global-loader ${loaderBackground && 'bg-white'}`}>
      <div className="circle-loader">
        <div className="f-loader-container">
          <svg className="f-loader" width="234" height="335" viewBox="0 0 234 335" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="67" height="134" fill="#3D4E5C" />
            <rect y="201" width="67" height="134" fill="#3D4E5C" />
            <rect x="67" width="167" height="67" fill="#3D4E5C" />
            <rect x="117" y="134" width="67" height="67" fill="#00AF9A" />
          </svg>
          <div className="third-loader">

          </div>
        </div>
      </div>
    </div>
  )
}

export default GlobalLoader
